import { useEffect, useState } from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { Permission } from 'interfaces';
import { useIsAdmin } from 'hooks/useIsAdmin';

interface CanModifyReturn {
  canModify: boolean;
}

export const useCanModify = (path: string): CanModifyReturn => {
  const { role } = useCurrentUserStore();
  const isAdmin = useIsAdmin();
  const [canModify, setCanModify] = useState<boolean>(true);

  useEffect(() => {
    if (isAdmin) {
      setCanModify(true);
    } else {
      const hasModifyPermission =
        role?.permissions?.some(
          (permission: Permission) =>
            permission.resource === path && permission.action === 'modify'
        ) ?? false;
      setCanModify(hasModifyPermission);
    }
  }, [isAdmin, path, role]);
  return { canModify };
};
